import { useEffect } from 'react'
import ClientService from '../services/client.service'


const useGetClientTableSchema = (dataTableSchema, setClientDataTableSchema) => {    
    useEffect(()=> {
        const getDataAndSchema = async () => {

            const serviceResponse = await ClientService.getPagedClients(dataTableSchema.pageNumber, dataTableSchema.pageSize, dataTableSchema.filters, dataTableSchema.orderField, dataTableSchema.orderAsc);
            const response = serviceResponse.data;

            setClientDataTableSchema(response);
        }
        
        if (dataTableSchema === null || dataTableSchema.data === null) {
            getDataAndSchema()
        }
    }, [dataTableSchema, setClientDataTableSchema]);
}
 
export { useGetClientTableSchema }